import React, { useRef } from "react";
import { useIsolateClick, useIsolateTouch } from "../../hooks/isolate";

export interface InteractionIsolateProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * A control's interactions are its own: nothing around it gets to read them as its own. Touches
 * stop here before they reach the player container, clicks before they reach the tile around;
 * `useIsolateTouch` and `useIsolateClick` say why one is native and the other React.
 * `display: contents` keeps the wrapper out of the layout.
 */
export const InteractionIsolate = ({ children, className, style }: InteractionIsolateProps) => {
  const ref = useRef<HTMLDivElement>(null);
  useIsolateTouch(ref);
  const stopClick = useIsolateClick();
  return (
    <div ref={ref} className={className} style={{ display: "contents", ...style }} onClick={stopClick}>
      {children}
    </div>
  );
};
